import * as React from 'react';
export const useToggle = (defaultState = false) => {
  const [isOn, setToggleState] = React.useState(defaultState);
  const toggle = React.useCallback((value = !isOn) => {
    setToggleState(value);
  }, [isOn]);
  return {
    toggle,
    isOn
  };
};